import QmEditor from './src/main';

/* istanbul ignore next */
QmEditor.install = function(Vue) {
  Vue.component(QmEditor.name, QmEditor);
};

export default QmEditor;
